import { Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

// ── What the viewport is showing ────────────────────────────────────
//
// A result preview draws the structure as it will be, in its own colour,
// with the live ROI hidden underneath. That is the picture the clinician
// is being asked to accept — but it is also a picture whose "nothing
// changed" case is INDISTINGUISHABLE from no preview at all: fill holes
// on a structure with no enclosed holes, a size floor below every part
// present, a crop box that already contains everything. An unchanged
// screen means either "this is the result" or "no preview drew", and the
// viewport cannot tell the two apart.
//
// So the panel says it in words, from the operation's OWN count of what
// it would change — not from anything inferred about the rendering — and
// only in that case, since otherwise the picture speaks for itself.

export default function PreviewResultStatus({
    isPreviewOnScreen,
    previewChangesNothing,
}: {
    /** An overlay for the settings currently on screen is displayed. */
    isPreviewOnScreen: boolean;
    /** The computed result is identical to the structure as it stands. */
    previewChangesNothing: boolean;
}) {
    if (!isPreviewOnScreen || !previewChangesNothing) {
        return null;
    }
    return (
        <Typography variant="body2" color="text.secondary">
            <FormattedMessage id="postProcessing.previewNoChange" />
        </Typography>
    );
}
